export default __webpack_public_path__ + "static/media/cover.99db635a.jpg";